module.exports = __webpack_public_path__ + "static/media/shoptimized-logo.62144dfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/shoptimized-logo.jpg
// module id = 2760
// module chunks = 0